import { CSSProperties } from "@material-ui/core/styles/withStyles";

// styles
import { greys } from "@clockwise/web-commons/src/styles/color.styles";

const input: CSSProperties = {
  padding: "0 !important",
};

const inputRoot: CSSProperties = {
  padding: "12px 14px !important",
  color: greys.slate,
  "& .MuiOutlinedInput-notchedOutline": {
    borderRadius: 5,
    border: `2px solid ${greys.paleGrey} !important`,
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: greys.paleGrey,
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: greys.paleGrey,
  },
};

const option: CSSProperties = {
  fontSize: 15,
  "& > span": {
    marginRight: 10,
    fontSize: 18,
  },
};

const root: CSSProperties = {};

export const styles = {
  input,
  inputRoot,
  option,
  root,
};
